import { TopBar, SideBar , Tabs, Footer} from "./"; 
import { ErrorBoundary } from "../utils/error_boundary"; 
import { useState } from "react";

const PageContainer = () => {
    const [side, setSide] = useState(false);
    return (
        <div id="wrapper">
            <SideBar side={side} setSide={setSide} />
            <div className="d-flex flex-column" id="content-wrapper">
                <div id="content" className="d-flex flex-column">
                    <TopBar side={side} setSide={setSide} />
                    <ErrorBoundary>
                        <Tabs />
                    </ErrorBoundary>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default PageContainer;